<template lang="pug">
  iframe#swbc-sales-frame(scrolling="no")
</template>

<script>
  import { mapGetters } from 'vuex'
  const SwbcSales = window.SwbcSales
  export default {
    name: 'SwbcSalesFrame',
    props: {
      mode: {
        type: String,
        required: true
      },
      quote: {
        type: Object,
        required: false
      },
      reservation: {
        type: Object,
        required: false
      },
      bookImmediately: {
        type: Boolean,
        required: false
      }
    },
    data () {
      return {
        sales: null
      }
    },
    computed: {
      ...mapGetters(['institutionId', 'swbcOrigin', 'randomPostfixedEmail'])
    },
    async mounted () {
      // Construct an instance of the integration
      console.log('Constructing sales frame...')
      this.sales = new SwbcSales({
        mode: this.mode,
        element: this.$el,
        institution: this.institutionId,
        origin: this.swbcOrigin
      })
      // Set your initialization callback
      // This hook is called when the SWBC Sales frame is ready to accept commands and emit events.
      console.log('Setting initialization handler on sales frame...')
      this.sales.init(() => {
        console.log('Ready signal received from SWBC Buy Now Sales iframe.')
        // This condition is present because in our Vue.js implementation,
        //   we chose to allow overloading a parametized component.
        // "selection" will open the GUI in the frame with selectable products
        //   once a quote event object is sent to it.
        if (this.mode === 'selection') {
          console.log('Frame was opened in "selection" mode.')
          this.quote.user.emailAddress = this.randomPostfixedEmail
          this.quoteRates(this.quote, (quotingError, quote) => {
            if (quotingError) {
              console.error(quotingError)
              return this.$emit('error', quotingError)
            }
            console.log('SDK received reply callback from "quote" command: ')
            console.log(quote)
            this.$emit('quote', quote)
          })
        }
        this.sales.on('reservation', (reservation) => {
          console.log('Reservation was selected: ')
          console.log(reservation)
          this.$emit('reservation', reservation)
          console.log(this.bookImmediately)
          if (this.bookImmediately) {
            console.log('Was set to book immediately.')
            this.bookReservation(reservation)
          }
        })
        if (this.reservation) {
          this.bookReservation(this.reservation)
        }
      })
    },
    methods: {
      quoteRates (quote, callback) {
        console.log('Executing quote publish to frame...', quote)
        this.sales.send('quote', quote, callback)
      },
      bookReservation ({ token, signature }) {
        console.log('Executing book command against SDK...', { token, signature })
        this.sales.send('book', { token, signature }, (bookingError, booking) => {
          if (bookingError) {
            console.error(bookingError)
            return this.$emit('error', bookingError)
          }
          console.log(booking)
          this.$emit('booked', booking)
        })
      }
    },
    beforeDestroy () {

    }
  }
</script>

<style lang="sass">
</style>
